import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  useMediaQuery,
  Card,
  CardContent,
  CardActions,
  Rating,
  Button,
  Collapse,
  useTheme,
  InputBase,
  IconButton,
  Divider,
  Paper,
  TextField,
  styled,
  Badge,
  FormControl,
  InputLabel,
  Select,
  Alert,
  AlertTitle,
} from "@mui/material";
import Header from "./Header";
import FlexBetween from "./FlexBetween";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Grid from "@mui/material/Unstable_Grid2";
import CardMedia from "@mui/material/CardMedia";
import Avatar from "@mui/material/Avatar";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TokenContext from "../context/TokenContext";
import { FormProvider, useForm } from "react-hook-form";
import { UserAuth } from "../context/AuthContext"; //IMPORTO PARA ACCEDER AL ESTADO DONDE ALMACENE PREVIAMENTE EL ID DEL EMPLEADO Y EL USUARIOPORTAL

import InfoIcon from "@mui/icons-material/Info";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { CameraAlt } from "@mui/icons-material";

import Skeleton from "@mui/material/Skeleton";
import { toast } from "react-toastify";
import { actualizarFotoUid } from "../Redux/usuarios";
import coverPhoto from "../img/campus.webp";
import {
  obtenerLocalidades,
  obtenerPaises,
  obtenerProvincias,
} from "../Redux/autocompletados";
import { useState } from "react";
import { MenuItem } from "react-pro-sidebar";
import FormularioLegajo from "./FormularioLegajo";
import { miLegajo } from "../Redux/legajo";
import { analytics } from '../Firebase'
const Legajo = () => {
  const dispatch = useDispatch();
  const token = useContext(TokenContext);
  const theme = useTheme();

  const [valuePrimerTab, setValuePrimerTab] = useState("1"); //value del tablist
  const [cardMediaSrc, setCardMediaSrc] = useState(coverPhoto);
  const [profilePicture, setProfilePicture] = useState("https://source.unsplash.com/random");
  const [legajo, setLegajo] = useState([]);
  const [loading, setLoading] = useState({});
  const legajoSelector = useSelector((store) => store.legajo.legajo);
  const loadingLegajoSelector = useSelector((store) => store.legajo.loadingLegajo);

  const { empleado, actualizarFotoPerfil, actualizarFotoPortada } = UserAuth();
  const location = useLocation();
  const paisesSelector = useSelector((store) => store.autocompletados.paises);
  const provinciasSelector = useSelector((store) => store.autocompletados.provincias);
  const loadingLocalidades = useSelector((store) => store.autocompletados.loadingLocalidades);

  const [paises, setPaises] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [localidades, setLocalidades] = useState([]);

  useEffect(() => {
    if (empleado && empleado.usuarioPortalRh) {
      // Extraer el nombre de usuario de la dirección de correo electrónico
      const userEmail = empleado.usuarioPortalRh;
      const userName = userEmail.split('@')[0];

      // Enviar el evento a Firebase Analytics con el nombre de usuario
      analytics.logEvent('screen_view', {
        screen_name: location.pathname,
        user_email: userName,
      });
    }
  }, [empleado, location]);

  useEffect(() => {
    if (token && empleado) {
      dispatch(miLegajo(token, empleado.empleadoid));
      dispatch(obtenerPaises(token));
      dispatch(obtenerProvincias(token));
      dispatch(obtenerLocalidades(token));
    }
  }, [token, empleado]);

  useEffect(() => {
    if (paisesSelector?.length > 0) {
      const paises = [];
      paisesSelector.forEach((item) => {
        const object = {
          value: item.new_paisid,
          label: item.new_name,
        };
        paises.push(object);
      });
      setPaises(paises);
    }
  }, [paisesSelector]);

  useEffect(() => {
    if (provinciasSelector?.length > 0) {
      const provincias = [];
      provinciasSelector.forEach((item) => {
        const object = {
          value: item.new_provinciaid,
          label: item.new_name,
        };
        provincias.push(object);
      });
      setProvincias(provincias);
    }
  }, [provinciasSelector]);

  useEffect(() => {
    if (loadingLocalidades?.length > 0) {
      const provincias = [];
      loadingLocalidades.forEach((item) => {
        const object = {
          value: item.new_localidadid,
          label: item.new_name,
        };
        provincias.push(object);
      });
      setLocalidades(provincias);
    }
  }, [loadingLocalidades]);

  useEffect(() => {
    setLoading(loadingLegajoSelector);
  }, [loadingLegajoSelector]);

  useEffect(() => {
    if (legajoSelector.length > 0) {
      var array = [];
      legajoSelector.forEach((item) => {
        var objeto = {
          new_apellidos: item.new_apellidos,
          new_nombredepila: item.new_nombredepila,
          new_usuariocanvas: item.new_usuariocanvas,
          new_numerolegajo: item.new_numerolegajo,
          email: item.new_correoelectronico,
          telefonoMovil: item.new_telefonomovil,
          telefonoParticular: item.new_telefonoparticular,
          extencionTefefonica: item.new_extenciontelefonica,
          new_tipodocumento: {
            label: item["new_tipodocumento@OData.Community.Display.V1.FormattedValue"],
            value: item.new_tipodocumento,
          },
          numeroDocumento: Number(item.new_nrodocumento),
          new_cuitcuil: item.new_cuitcuil,
          new_estadocivil:
            item["new_estadocivil@OData.Community.Display.V1.FormattedValue"],
          estadoCivil: {
            label:
              item["new_estadocivil@OData.Community.Display.V1.FormattedValue"],
            value: item.new_estadocivil,
          },
          new_genero: item["new_genero@OData.Community.Display.V1.FormattedValue"],
          new_correoelectronicopersonal: item.new_correoelectronicopersonal,
          new_paisnacimiento: item["_new_paisnacimiento_value@OData.Community.Display.V1.FormattedValue"],
          paisNacimiento: {
            label:
              item["_new_paisnacimiento_value@OData.Community.Display.V1.FormattedValue"],
            value: item._new_paisnacimiento_value,
          },
          fechaNacimiento: item.new_fechanacimiento,
          edad: item.new_edad,
          calle: item.new_calle,
          piso: item.new_piso,
          nroCalle: item.new_nro,
          depto: item.new_depto,
          new_localidad:
            item[
            "_new_localidad_value@OData.Community.Display.V1.FormattedValue"
            ],
          localidad: {
            label:
              item[
              "_new_localidad_value@OData.Community.Display.V1.FormattedValue"
              ],
            value: item._new_localidad_value,
          },
          new_barrio: item.new_barrio,
          new_codigopostal: item.new_codigopostal,
          new_provincia:
            item[
            "_new_provincia_value@OData.Community.Display.V1.FormattedValue"
            ],
          provincia: {
            label:
              item[
              "_new_provincia_value@OData.Community.Display.V1.FormattedValue"
              ],
            value: item._new_provincia_value,
          },
          provinciaNacimiento: {
            label: item["_new_provincianacimiento_value@OData.Community.Display.V1.FormattedValue"],
            value: item._new_provincianacimiento_value,
          },
          new_pais:
            item["_new_pais_value@OData.Community.Display.V1.FormattedValue"],
          pais: {
            label:
              item["_new_pais_value@OData.Community.Display.V1.FormattedValue"],
            value: item._new_pais_value,
          },
        };
        array.push(objeto);
      });
      setLegajo(array);
    }
  }, [legajoSelector]);

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue);
  };

  const handleCardMediaChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      setCardMediaSrc(e.target.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleProfilePictureChange = (event) => {
    const file = event.target.files[0];

    if (file === undefined) {
      console.log("no se selecciono ninguna imagen");
      return;
    }

    if (
      file.type !== "image/png" &&
      file.type !== "image/jpg" &&
      file.type !== "image/jpeg"
    ) {
      toast.error("El formato de la foto debe ser png/jpg/jpeg", {
        theme: "dark",
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const imageDataUrl = reader.result;
      const imgBlob = dataURLToBlob(imageDataUrl); // Convertir el data URL a un blob
      actualizarFotoPerfil(imgBlob).then(() => {
        setProfilePicture(imageDataUrl);
      });
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleCoverPictureChange = (event) => {
    const file = event.target.files[0];

    if (file === undefined) {
      console.log("no se selecciono ninguna imagen");
      return;
    }

    if (
      file.type !== "image/png" &&
      file.type !== "image/jpg" &&
      file.type !== "image/jpeg"
    ) {
      toast.error("El formato de la foto debe ser png/jpg/jpeg", {
        theme: "dark",
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const imageDataUrl = reader.result;
      const imgBlob = dataURLToBlob(imageDataUrl); // Convertir el data URL a un blob
      actualizarFotoPortada(imgBlob).then(() => {
        setProfilePicture(imageDataUrl);
      });
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  // Función auxiliar para convertir un data URL a un blob
  const dataURLToBlob = (dataURL) => {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <TabContext value={valuePrimerTab}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Card
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  background: theme.palette.primary.main + 10,
                }}
              >
                <CardContent>
                  <Grid container spacing={3}>
                    {/* {empleado.photoPORTADA !== "" &&
                    empleado.photoPORTADA !== undefined &&
                    empleado.photoPORTADA !== null ? (
                      <CardMedia
                        component="img"
                        src={empleado.photoPORTADA}
                        alt="Foto de portada1"
                        sx={{
                          height: "200px",
                          borderRadius: 1,
                          objectFit: "cover",
                        }}
                      />
                    ) : ( */}
                    <CardMedia
                      component="img"
                      src={cardMediaSrc}
                      alt="Foto de portada2"
                      sx={{
                        height: "200px",
                        borderRadius: 1,
                        objectFit: "cover",
                      }}
                    />
                    {/* )} */}
                    {/* <div style={{ position: "relative" }}>
                      <IconButton
                        color="primary"
                        component="label"
                        htmlFor="card-media-upload"
                        sx={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          borderRadius: "50%",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                          },
                        }}
                      >
                        <input
                          id="card-media-upload"
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleCoverPictureChange}
                        />
                        <CameraAlt
                          sx={{
                            color: "#1c1e21",
                          }}
                        />
                      </IconButton>
                    </div> */}
                    <Grid item xs={12}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                          <Badge
                            overlap="circular"
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            badgeContent={
                              <label htmlFor="profile-picture-upload">
                                <input
                                  id="profile-picture-upload"
                                  type="file"
                                  style={{ display: "none" }}
                                  onChange={handleProfilePictureChange}
                                />
                                <IconButton
                                  component="span"
                                  sx={{
                                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor:
                                        "rgba(255, 255, 255, 0.9)",
                                    },
                                  }}
                                >
                                  <CameraAlt sx={{ color: "#1c1e21" }} />
                                </IconButton>
                              </label>
                            }
                          >
                            {empleado.photoURL !== "" &&
                              empleado.photoURL !== undefined &&
                              empleado.photoURL !== null ? (
                              <Avatar
                                src={empleado.photoURL}
                                alt="Foto de perfil"
                                sx={{
                                  width: 160,
                                  height: 160,
                                  border: "4px solid #fff",
                                  margin: "0 auto",
                                  marginTop: "-90px",
                                }}
                              />
                            ) : (
                              <Avatar
                                src={profilePicture}
                                alt="Foto de perfil"
                                sx={{
                                  width: 160,
                                  height: 160,
                                  border: "4px solid #fff",
                                  margin: "0 auto",
                                  marginTop: "-90px",
                                }}
                              />
                            )}
                          </Badge>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              md={12}
                              sx={{ marginTop: "-20px" }}
                            >
                              <Typography variant="h2">
                                {legajo[0]?.new_nombredepila && legajo[0]?.new_apellidos
                                  ? `${legajo[0]?.new_nombredepila} ${legajo[0]?.new_apellidos}`
                                  : ""}
                              </Typography>
                              {/* <Typography variant="subtitle1">Docente</Typography> */}
                            </Grid>
                          </Grid>
                          <Grid container>
                            <TabList
                              aria-label="scrollable force tabs example"
                              onChange={handleChangePrimerTAB}
                              variant="scrollable"
                              scrollButtons="auto"
                              allowScrollButtonsMobile
                              textColor="secondary"
                              indicatorColor="secondary"
                            >
                              <Tab
                                label={
                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <InfoIcon sx={{ marginRight: "8px" }} /> */}
                                    Información
                                  </span>
                                }
                                value="1"
                                sx={{ fontWeight: "bold", fontSize: "16px" }}
                              />
                            </TabList>
                          </Grid>
                          {/* Contenido adicional del perfil */}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Box sx={{ mt:2}}>

            <Alert severity="info">
              <AlertTitle>Info</AlertTitle>
              Visualizá tus datos personales cargados en la organización. Si deseas modificarlos, presioná el botón <strong>“ACTUALIZAR”</strong> al final de esta sección o directamente desde la sección <strong>“Solicitudes”</strong>.
            </Alert>
          </Box>
          <TabPanel value="1" sx={{ mt: 2, p: 0 }}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 3,
                background: theme.palette.primary.main + 10,
                mb: 2,
              }}
            >
              <CardContent>
                {legajo.length > 0 ? (
                  <FormularioLegajo legajo={legajo[0]} paises={paises} provincias={provincias} localidades={localidades} />
                ) : (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton variant="rectangular" />
                    </Grid>
                  </Grid>
                )}
              </CardContent>
            </Card>
          </TabPanel>
        </TabContext>
      </Box>
    </motion.div>
  );
};

export default Legajo;